var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"contenedor"},[_c('div',{staticClass:"font-weight-bold",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n    Decreto 1630 - Lista de productos\n  ")]),_c('FormSearch'),_c('DataTable',{staticClass:"mt-5"}),_c('ModalLoadFile'),_c('ModalProcessBackground')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }